<div class="subBlockContainer">
    <div class="subBlockContent blade-size">
        <child-header [title]="title" (closeEvent)="close()"></child-header>
        <div class="child-body">
            <div class="inner-subBlock-wrapper">
                <!-- <div class="page-title-wrapper">
                    <div class="title blade-title-font">
                        {{title}}
                    </div>
                    <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
                </div> -->
                <div id="basic-info-wrapper">
                    <div class="info-secondary-title-wrapper">
                        <span class="bold-text">COMPANY NAME:&nbsp;</span>
                        <span>{{companyInfo?.companyName}}</span>
                        <span class="divider-wrapper" *ngIf="companyInfo?.abn">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <span class="infoSection-content-title" *ngIf="companyInfo?.abn">ABN:&nbsp;</span>
                        <span class="ng-star-inserted" *ngIf="companyInfo?.abn">{{companyInfo?.abn}}</span>
                        <!-- <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <span class="infoSection-content-title">ADDRESS:&nbsp;</span> -->
                        <div><span class="bold-text">ADDRESS</span>: {{combinedAddress}}</div>
                        <div><span class="bold-text">Main Contact</span>: {{companyInfo?.mainContact}}</div>
                    </div>
                    <span>
                        <button id="update-button" class="font-col-highlight"
                            (click)="openVerticallyCentered(content)">Request Update</button>
                    </span>
                </div>
                <div class="top-divider"></div>
                <!-- BEGIN OF EXTENDED COMPANY INFORMATION FORM -->
                <form id="extended-info-wrapper" [formGroup]="companyInfoForm">
                    <div class="form-group text-uppercase row">
                        <div class="col-md-6" >
                            <mat-form-field [floatLabel]="'always'">
                                <input matInput placeholder="COMPANY EMAIL" (keypress)="noSpace($event)" formControlName="email">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field [floatLabel]="'always'">
                                <input matInput placeholder="COMPANY LINKEDIN" formControlName="linkedin">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group text-uppercase row">
                        <div class="col-md-6">
                            <mat-form-field [floatLabel]="'always'">
                                <input matInput placeholder="COMPANY PHONE" (keypress)="isNumberKey($event)" formControlName="phone">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field [floatLabel]="'always'">
                                <input matInput placeholder="COMPANY FACEBOOK" formControlName="facebook">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group text-uppercase row">
                        <div class="col-md-6">
                            <mat-form-field [floatLabel]="'always'">
                                <input matInput placeholder="COMPANY WEBSITE" formControlName="website">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field [floatLabel]="'always'">
                                <input matInput placeholder="COMPANY TWITTER" formControlName="twitter">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-6" formGroupName="business">
                            <p class="mat-element-title">How do you classify your business?</p>
                            <div class="checkbox-padding">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="ecom" [checked]="companyInfoForm.value.business.ecom.value" [attr.disabled]="companyInfoForm.value.business.ecom.disabled">E-Commerce</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="isv"  [checked]="companyInfoForm.value.business.isv.value" [attr.disabled]="companyInfoForm.value.business.isv.disabled">Integrated Software Vendor</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="msp" [checked]="companyInfoForm.value.business.msp.value" [attr.disabled]="companyInfoForm.value.business.msp.disabled">Managed Service Provider</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="retail" [checked]="companyInfoForm.value.business.retail.value" [attr.disabled]="companyInfoForm.value.business.retail.disabled">Retail</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="si" [checked]="companyInfoForm.value.business.si.value" [attr.disabled]="companyInfoForm.value.business.si.disabled">Systems Integrator</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="var" [checked]="companyInfoForm.value.business.var.value" [attr.disabled]="companyInfoForm.value.business.var.disabled">Value Added Reseller</mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <mat-radio-group class="col-md-6" formControlName="primaryFocus" (change)="tickItemForBusiness($event)">
                            <p class="mat-element-title">Which of your classifications is your
                                primary focus?</p>
                            <div class="checkbox-padding">
                                <div class="col-md-12">
                                    <mat-radio-button value="ecom">E-Commerce</mat-radio-button>
                                </div>
                                <div class="col-md-12">
                                    <mat-radio-button value="isv">Integrated Software Vendor</mat-radio-button>
                                </div>
                                <div class="col-md-12">
                                    <mat-radio-button value="msp">Managed Service Provider</mat-radio-button>
                                </div>
                                <div class="col-md-12">
                                    <mat-radio-button value="retail">Retail</mat-radio-button>
                                </div>
                                <div class="col-md-12">
                                    <mat-radio-button value="si">Systems Integrator</mat-radio-button>
                                </div>
                                <div class="col-md-12">
                                    <mat-radio-button value="var">Value Added Reseller</mat-radio-button>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <mat-radio-group class="form-group row" formControlName="endUserEverageSize">
                    <!-- <mat-radio-group class="form-group row" [(ngModel)]="selectedAverageUserSize" [ngModelOptions]="{standalone: true}"> -->
                        <div class="col-md-12">
                            <p class="mat-element-title">What is the average size of the end-users
                                you service today?</p>
                        </div>
                        <div class="col-md-4">
                            <mat-radio-button value="0-250">0 to 250</mat-radio-button>
                        </div>
                        <div class="col-md-5 align-center">
                            <mat-radio-button value="250-2000">250 to 2000</mat-radio-button>
                        </div>
                        <div class="col-md-3 align-center">
                            <mat-radio-button value="2000+">2000+</mat-radio-button>
                        </div>
                    </mat-radio-group>
                    <div class="form-group row" formGroupName="primaryTarget">
                        <div class="col-md-12">
                            <p class="mat-element-title">Which industry verticals do you primarly
                                target:</p>
                        </div>
                        <div class="col-md-6">
                            <div class="checkbox-padding">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="agricultureForestryAndFishing">Agriculture, Forestry and Fishing</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="consumer">Consumer</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="education">Education</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="governmentAndDefence">Government and Defence</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="informationAndCommunicationTechnology">Information and Communication Technology</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="manufacturing">Manufacturing</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="rentalHiringRealEstateServices">Rental, Hiring, Real Estate Services</mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="checkbox-padding">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="artsAndRecreation">Arts and Recreation</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="constructionAndEngineering">Construction and Engineering</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="financeAndInsurance">Finance and Insurance</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="healthcareAndMedical">Healthcare and Medical</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="legal">Legal</mat-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="miningAndResources">Mining and Resources</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- END OF EXTENDED COMPANY INFORMATION FORM -->
                <div class="top-divider"></div>

                <!-- BEGIN OF MODAL -->
                <ng-template #content let-c="close" let-d="dismiss">
                <div class="company-info-model">
                    <child-header title="Request Update" (closeEvent)="d('Cross click')"></child-header>
                    <div class="modal-body">
                        <form [formGroup]="companyForm" id="basic-form-wrapper">
                            <textarea type="texta" formControlName="message"
                                placeholder="Please provide our team with some context as to why you'd like to update your core company information."
                                class="request-text-area"></textarea>
                            <div class="form-group row">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="companyName" class="control-label required">COMPANY NAME</label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <input type="text" id="companyName" class="form-control" formControlName="companyName"> -->
                                    <mat-form-field [floatLabel]="'always'">
                                        <input matInput id="companyName" formControlName="companyName" placeholder="COMPANY NAME*">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12 error-msg" *ngIf="isFieldValid('companyName')">
                                    <div class="arrow-up"></div>
                                    <div class="msg">Please enter your company name</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="mainContact" class="control-label required">MAIN CONTACT</label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <input type="text" id="mainContact" class="form-control" formControlName="mainContact"> -->
                                    <mat-form-field [floatLabel]="'always'">
                                        <input matInput id="mainContact" formControlName="mainContact" placeholder="MAIN CONTACT*">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12 error-msg" *ngIf="isFieldValid('mainContact')">
                                    <div class="arrow-up"></div>
                                    <div class="msg">Please enter your main contact</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="addressLine" class="control-label required">
                                        ADDRESS LINE 1</label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <input type="text" id="addressLine" class="form-control" formControlName="addressLine"> -->
                                    <mat-form-field [floatLabel]="'always'">
                                        <input matInput id="addressLine" formControlName="addressLine" placeholder="ADDRESS LINE 1*">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12 error-msg" *ngIf="isFieldValid('addressLine')">
                                    <div class="arrow-up"></div>
                                    <div class="msg">Please enter your address</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="addressLine2" class="control-label required">ADDRESS LINE 2 </label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <input type="text" id="addressLine2" class="form-control"
                                        formControlName="addressLine2"> -->
                                        <mat-form-field [floatLabel]="'always'">
                                            <input matInput id="addressLine2" formControlName="addressLine2" placeholder="ADDRESS LINE 2">
                                        </mat-form-field>
                                </div>
                            </div>

                            <div class="form-group row">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="suburb" class="control-label required">SUBURB</label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <input type="text" id="suburb" class="form-control" formControlName="suburb"> -->
                                    <!-- (keyup)="startFilterSub()" -->
                                    <mat-form-field [floatLabel]="'always'">
                                        <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger" (suburb)="startFilterSub($event)" (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="suburb"
                                        placeholder="SUBURB*" (keydown.Tab)="chooseAutoCompletSuburb($event)" >
                                        <mat-autocomplete #autoSuburb="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                                            (click)="chooseAutoComplete(option)">
                                            {{option.state?option?.suburb+", "+option?.state+", "+option?.postcode:option?.suburb+", "+option?.postcode}}
                                            <!-- {{option?.suburb+", "+option?.state+", "+option?.postcode}} -->
                                        </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12 error-msg" *ngIf="isFieldValid('suburb')">
                                    <div class="arrow-up"></div>
                                    <div class="msg">Please enter your suburb</div>
                                </div>
                            </div>
                            <div class="form-group row" style="margin-bottom: 0 !important;">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="state" class="control-label required">STATE</label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <mat-form-field>
                                        <mat-select>
                                            <mat-option value="noMatchedState">--Choose the state--</mat-option>
                                            <mat-option *ngFor="let state of stateList" value="{{state}}">{{state}}</mat-option>
                                        </mat-select>
                                    </mat-form-field> -->
                                    <ng-select class="customDropdwon stateValidate" [items]="stateList" bindValue="state" bindLabel="state"
                                        formControlName="state" placeholder="STATE*"></ng-select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <!-- <div class="col-md-12 from-label">
                                    <label for="postcode" class="control-label required">POSTCODE</label>
                                </div> -->
                                <div class="col-md-12">
                                    <!-- <input type="text" id="postcode" class="form-control" formControlName="postcode"> -->
                                    <!-- (keyup)="startFilterPostcode()" (keypress)="isNumberKey($event)" -->
                                    <mat-form-field [floatLabel]="'always'">
                                        <input matInput class="postcodeValidate" maxlength="4" (input)="onInputPostcode($event)"  (postcode)="startFilterPostcode($event)" #myAutocompleteTriggerPostcode="matAutocompleteTrigger" 
                                        formControlName="postcode" (keypress)="isNumberKey($event)" (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode" placeholder="POSTCODE*">
                                        <mat-autocomplete #autoPostcode="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                                            (click)="chooseAutoComplete(option)">
                                            {{option.state?option?.suburb+", "+option?.state+", "+option?.postcode:option?.suburb+", "+option?.postcode}}
                                            <!-- {{option?.suburb+", "+option?.state+", "+option?.postcode}} -->
                                        </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12 error-msg" *ngIf="isFieldValid('postcode')">
                                    <div class="col-md-12 error-msg" *ngIf="companyForm.get('postcode').errors?.required">
                                        <div class="arrow-up"></div>
                                        <div class="msg">Please enter your postcode</div>
                                    </div>
                                    <div class="col-md-12 error-msg"
                                        *ngIf="companyForm.get('postcode').errors?.minlength || companyForm.get('postcode').errors?.maxlength">
                                        postcode must be a 4-digit number</div>
                                </div>
                            </div>
                            <!-- <div class="form-group row">
                                <div class="col-md-12 from-label">
                                    <label for="phone" class="control-label required">PHONE *</label>
                                </div>
                                <div class="col-md-12">
                                    <input type="text" id="phone" class="form-control" formControlName="phone">
                                </div>
                                <div class="col-md-12 error-msg" *ngIf="isFieldValid('phone')">
                                    <div class="arrow-up"></div>
                                    <div class="msg">Please enter your phone</div>
                                </div>
                            </div> -->

                            <div class="form-group row">
                                <div class="col-md-12  align-center">
                                    <button type="button" id="submit-companyInfo-button"
                                        class="button button-red button-large margin-t-x15" (click)="submitToAccounts()">Send</button>
                                </div>
                            </div>
                            <p class="footer">Any changes to your company's core information has to be reviewed and approved
                                by Dicker Data before the amendments can be applied to your account. All change requests are
                                usually responded to within 48 hours.</p>
                        </form>
                    </div>
                </div>
                </ng-template>
                <!-- END OF MODAL -->
                <div class="align-center">
                    <button id="save-extended-info-button" class="button button-red button-large margin-t-x10" (click)="saveCompanyInfo()">Save</button>
                </div>
            </div>
        </div>
        <loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth='675'
            (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>

</div>
